import * as React from "react";

const IdBadgeIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x2="1"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#02a"></stop>
        <stop offset="1" stopColor="#1a64b9"></stop>
      </linearGradient>
    </defs>
    <path
      id="id-badge"
      fill="url(#linear-gradient)"
      d="M19 4h-4V3a3 3 0 1 0-6 0v1H5a5.006 5.006 0 0 0-5 5v10a5.006 5.006 0 0 0 5 5h14a5.006 5.006 0 0 0 5-5V9a5.006 5.006 0 0 0-5-5m-8-1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0Zm11 16a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h4.184a2.982 2.982 0 0 0 5.632 0H19a3 3 0 0 1 3 3Zm-12-9H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1m-1 8H6v-6h3Zm11-3a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 1 1m0-4a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 1 1m-2 8a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1"
    ></path>
  </svg>
);

export default IdBadgeIcon;
